import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import '@/index.css';
import App from '@/App';
import { AuthProvider } from '@/context/AuthContext';
import { PresentationProvider } from '@/context/PresentationContext';
import { Toaster } from '@/components/ui/sonner';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { staleTime: 30_000, refetchOnWindowFocus: false },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <PresentationProvider>
                    <App />
                    <Toaster position="top-right" />
                </PresentationProvider>
            </AuthProvider>
        </QueryClientProvider>
    </React.StrictMode>,
);
